<template>
  <div class="content">
    <div class="container-fluid p-0 col-6">
      <card>
        <h4 slot="header" class="card-title">Změna hesla</h4>
        <form>
          <div class="row">
            <div class="col-8">
              <base-input type="password" label="Původní heslo" v-model="passwordObject.OldPassword" />
              <div v-if="submitted && !$v.passwordObject.OldPassword.required" class="invalid-feedback d-block">Původní heslo je povinné</div>
            </div>
          </div>

          <div class="row">
            <div class="col-8">
                <base-input type="password" label="Nové heslo" v-model="passwordObject.NewPassword" />
                <div v-if="submitted && !$v.passwordObject.NewPassword.required" class="invalid-feedback d-block">Nové heslo je povinné</div>
            </div>
          </div>

          <div class="row">
            <div class="col-8">
                <base-input type="password" label="Nové heslo znova" v-model="passwordObject.NewPasswordAgain" />
                <div v-if="submitted && !$v.passwordObject.NewPasswordAgain.required" class="invalid-feedback d-block">Nové heslo znova je povinné</div>
            </div>
          </div>

          <hr>
          <div class="text-center">
            <button type="submit" class="btn btn-success btn-fill float-right" @click.prevent="saveData">
              Uložit a odhlásit
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </card>
    </div>
    <div id="snackbar">{{msg}}</div>
  </div>
</template>

<script>
  import Card from '@/components/Cards/Card.vue';
  import dataService from '@/services/dataService.js';
  import { required } from "vuelidate/lib/validators";
  import JQuery from 'jquery';

  let $ = JQuery

  export default {
    components: {
      Card
    },
    methods: {
      async saveData() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }

        try {
            if (this.passwordObject.NewPassword !== this.passwordObject.NewPasswordAgain) {
                throw 'Hesla se neshodují!'
            }

            await dataService.changePassword(this.passwordObject.OldPassword, this.passwordObject.NewPassword, this.$store.getters.getUser.Id);
            this.$store.dispatch('logout');
            this.$router.push('/login');
        } catch (error) {
            try {
                this.msg = error.response.data.msg;
            } catch (err) {
                this.msg = error;
            }
            
            var x = document.getElementById("snackbar");
            x.className = "show";
            setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
        }
      }
    },
    data () {
      return {
        msg: '',
        submitted: false,
        passwordObject: {
          OldPassword: null,
          NewPassword: null,
          NewPasswordAgain: null
        }
      }
    },
    validations: {
      passwordObject: {
        OldPassword: { required },
        NewPassword: { required },
        NewPasswordAgain: { required }
      }
    }
  }
</script>